const preventorsMap = {
    student_enrollment: {
        single: 'inschrijving op een cursusonderdeel (Zie Cursussen > Planning)',
        multiple: 'inschrijvingen op cursusonderdelen (Zie Cursussen > Planning)',
    },
    incompany_appointment: {
        single: 'incompany training',
        multiple: 'incompany trainingen',
    }
}

function showDisablePreventors(preventors) {
    const reasons = [];
    Object.keys(preventors).forEach((preventor) => {
       const count = preventors[preventor];
         const reason = preventorsMap[preventor][count > 1 ? 'multiple' : 'single'];
         reasons.push(`${count} ${reason}`);
    });
    const errorText = `Deactiveren niet mogelijk: ${reasons.join(', ')}`;
    squde_flash(errorText, 'alert');
}
